import * as yup from 'yup';
import { schema as heroSchema } from '../../cms/builders/hero';
import { schema as pollSchema } from '../../cms/builders/confirmation_poll';
import { schema as bannerSchema } from '../../cms/builders/confirmation_banner';
import { schema as getSocialSchema } from '../../cms/builders/get_social_component';

export const confirmationSchema = yup
  .object({
    hero: heroSchema,
    orderSummaryTitle: yup.string().required(),
    leftSideComponents: yup.array(
      yup.lazy(item => {
        switch (item.component) {
          case 'confirmation_poll':
            return pollSchema.required();
          default:
            return bannerSchema.required();
        }
      }),
    ),
    rightSideComponents: yup.array(
      yup.lazy(item => {
        switch (item.component) {
          case 'get_social_component':
            return getSocialSchema.required();
          default:
            return yup.object();
        }
      }),
    ),
  })
  .transform(value => ({
    hero: value.hero[0],
    leftSideComponents: value.left_side_components,
    rightSideComponents: value.right_side_components,
    orderSummaryTitle: 'Order Summary',
  }));
